import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';

const stayDataForm: Form<Client> = {
  key: 'stayData',
  title: 'Aufenthalt',
  fields: [
    {
      key: 'responsibleImmigrationOffice',
      label: 'zuständige Ausländerbehörde',
      fieldTypes: 'text',
    },
    {
      key: 'residenceStatus',
      label: 'Aufenthaltsstatus',
      fieldTypes: 'text',
    },
    {
      key: 'entryDate',
      label: 'Einreise nach Deutschland',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'entryValidTillDate',
      label: 'Gültig bis',
      fieldTypes: 'date',
      xsWidth: 4,
    },
    {
      key: 'paragraph',
      label: 'Paragraph',
      fieldTypes: 'text',
      xsWidth: 4,
    },
    {
      key: 'lawyer',
      label: 'Anwält*in',
      fieldTypes: 'text',
      xsWidth: 12,
    },
  ],
};

export default stayDataForm;
